import { render, staticRenderFns } from "./ModalScreen.vue?vue&type=template&id=61a79f24"
import script from "./ModalScreen.vue?vue&type=script&lang=js"
export * from "./ModalScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/vercel/path0/components/common/Button.vue').default})
